import { ContractDocumentsRequestInterface } from '../../../../interfaces/request/contracts/contract-documents-request/contract-documents-request-interface';

export class ContractDocumentsRequestModel implements ContractDocumentsRequestInterface {
  featureName: string = '';
  policyId: number | undefined;

  constructor(init?: Partial<ContractDocumentsRequestModel>) {
    Object.assign(this, init);
  }
}
